export const createTransactionID = (isCorrelationId: boolean = false) => {
  let currentDateTime = new Date().toISOString().replace(/-|:|T/gi, '').replace('.', '').slice(2).slice(0, -1);
  return 'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000);
}